import { ReactNode } from 'react'

export enum ModalTypeE {
  FULL_SIZE = 'FULL_SIZE',
  DEFAULT = 'DEFAULT',
}

export interface IModalProps {
  children: ReactNode
  width?: number | string
  scrollable?: boolean
  onClose?: () => void
  closeOnClickOutside?: boolean
  showCloseButton?: boolean
  type?: ModalTypeE
}

export interface IModalContext {
  onClose?: IModalProps['onClose']
  showCloseButton?: IModalProps['showCloseButton']
  type: IModalProps['type']
}

export interface IHeaderProps {
  title?: ReactNode
}
